import { useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { showError, showSuccess } from "./Utils/toastUtils";
import { motion, AnimatePresence } from "framer-motion";
import { nanoid } from "nanoid";
import { modals } from "../components/Utils/DescripcionesPlatos"
import { PageModal } from "./Utils/CustomStyles";
import { FaHamburger, FaTimes, FaChevronDown } from "react-icons/fa";
import PromoDuo from "./PromoDuo";
import PromoHotDog from "./PromoHotDog";
import PLunesYmartes from "./PLunesYmartes";
import { useItems } from "../Hooks/useItems";
import PromoCarne from "../img/ImgProducts/classic.webp"
import Logo from "../img/Logotipo.webp"



const ingredientes =["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]


const ModalInicio = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  // 🗓️ Filtrar promos por día
  const hoy = new Date().getDay(); // 0=dom, 1=lun, 2=mar, 3=mie, 4=jue, 5=vie, 6=sab
  const esLunesOMartes = hoy === 1 || hoy === 2;
  const esMiercolesOJueves = hoy === 3 || hoy === 4;

    // Promo LM (Lunes y Martes de Bajo Presupuesto) solo lun/mar; Promo Duo todos los días
    const modalsFiltrados = modals.filter(m => {
      if (m.tipo === "lm") {
        return esLunesOMartes;
      }
      if (m.tipo === "duo") {
        return true;
      }
      if (m.tipo === "mj") {
        return esMiercolesOJueves;
      }
      return true;
    });

  const [isImageExpanded, setIsImageExpanded] = useState(null);
  const [mostrarModalPreparacion, setMostrarModalPreparacion] = useState(false);
  const [mostrarModalAgregarMas, setMostrarModalAgregarMas] = useState(false);
  const [promoSeleccionada, setPromoSeleccionada] = useState(null);
  const [preparacion, setPreparacion] = useState("");
  const { 
    platosSeleccionados: promosSeleccionadas, 
    setPlatosSeleccionados: setPromosSeleccionadas 
  } = useItems("promosSeleccionadas");
  const [promoTemporal, setPromoTemporal] = useState(null); // para manejo interno
  const [mostrarPopover, setMostrarPopover] = useState(false);
  const [promoAnchor, setPromoAnchor] = useState(null); // botón anclado
  const [promoConSubopciones, setPromoConSubopciones] = useState(null);
  const [indexModalActual, setIndexModalActual] = useState(0);
  const [interactuando, setInteractuando] = useState(false);
  const [primeraRotacion, setPrimeraRotacion] = useState(true);
  const [direccionUsuario, setDireccionUsuario] = useState(0); // -1 = atrás, 1 = adelante
  const [mostrarModal, setMostrarModal] = useState(false);
  const [preparacionMultiple, setPreparacionMultiple] = useState([]);
    const [bebidaSeleccionada, setBebidaSeleccionada] = useState(null);

    const [hamburguesaExpandida, setHamburguesaExpandida] = useState(null);
  const [proteinaSeleccion, setProteinaSeleccion] = useState("")
const [exclusionesAbierto, setExclusionesAbierto] = useState(false);
const [exclusiones, setExclusiones] = useState([]);



    // Guardar en localStorage automáticamente cuando cambien las promos seleccionadas

useEffect(() => {
  if (mostrarModalPreparacion && promoTemporal) {
    const cantidad =
      promoTemporal?.cantidad ??
      promoTemporal?.parentPromo?.cantidad ??
      promoTemporal?.promo?.cantidad ??
      1; // valor por defecto 1 si no está definido

    // Si ya existe un array con la longitud correcta lo dejamos, si no, lo inicializamos vacío
    setPreparacionMultiple(prev => {
      if (Array.isArray(prev) && prev.length === cantidad) return prev;
      return Array.from({ length: cantidad }, () => ""); // inicializa con strings vacíos
    });
  }
}, [mostrarModalPreparacion, promoTemporal]);

  useEffect(() => {
    if (!interactuando) {
      const delay = primeraRotacion ? 6000 : 3000; // 6s primera vez, 3s después
      const timer = setTimeout(() => {
        setIndexModalActual(prev => (prev + 1) % modalsFiltrados.length);
        if (primeraRotacion) setPrimeraRotacion(false); // después de la primera
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [indexModalActual, interactuando, primeraRotacion, modalsFiltrados.length]);

useEffect(() => {
  if (mostrarModalPreparacion && promoTemporal?.cantidad) {
    setPreparacionMultiple(Array.from({ length: promoTemporal.cantidad }, () => ""));
  }
}, [mostrarModalPreparacion, promoTemporal]);

// Función para agregar la promo al estado (el useEffect se encarga de persistir)
const handleAgregarPromoDuo = (promo) => {
    const nuevaPromo = {
        id: nanoid(),
        nombre: promo.nombre,
        precio: promo.precio,
        img: promo.img || null,
        productoImg: promo.img || null,
        promo: { ...promo }
    };
    setPromosSeleccionadas(prev => [...prev, nuevaPromo]);
};

// Función para ir al modal "Agregar algo más"
const handleSiguientePromoDuo = () => {
    setMostrarModalAgregarMas(true);
};


const cantidadHamburguesas = promoTemporal?.promo?.cantidad || promoTemporal?.cantidad || null;

  
  const irSiguiente = () => { 
    setInteractuando(true);      // indicamos que es interacción del usuario
    setDireccionUsuario(1);      // avanzar → animación derecha a izquierda
    setIndexModalActual((prev) => (prev === modalsFiltrados.length - 1 ? 0 : prev + 1));
  };

  const irAnterior = () => {
    setInteractuando(true);
    setDireccionUsuario(-1);     // retroceder → animación izquierda a derecha
    setIndexModalActual((prev) => (prev === 0 ? modalsFiltrados.length - 1 : prev - 1));
  };

 const handlePromoClick = (promoPadre, promoHijo = null) => {
  const nombreFinal = promoHijo?.nombre || promoPadre.nombre;
  
  // Si la promo tiene preparacion o bebida
  if (promoPadre.preparacion || promoPadre.bebida) {
    setPromoTemporal({
      nombre: nombreFinal,
      precio: promoHijo?.precio || promoPadre.promos[0]?.precio,
      cantidad: promoPadre.cantidad,
      opcionesPorUnidad: promoPadre.opcionesPorUnidad || [],
      opcionesPreparacion: promoPadre.opcionesPreparacion || [],
      preparacion: promoPadre.preparacion,
      bebida: promoPadre.bebida,
      parentPromo: promoPadre,
      img: promoPadre.img || null,
      nombrePadre: promoPadre.nombre,
      tipo: promoPadre.tipo, // Conservar el tipo (lm, duo, hd, mj)
    });
    setMostrarModalPreparacion(true);
  } else {
    // Si la promo no tiene preparación ni bebida (ej: promos MJ), agregar directamente
    const tipoSeleccion = promoHijo?.tipoSeleccion || null;
    const nuevaPromo = {
      id: nanoid(),
      nombre: nombreFinal,
      precio: promoHijo?.precio || promoPadre.promos[0]?.precio,
      tipoSeleccion,
      preparacion: null,
      hamburguesas: [],
      bebidaSeleccionada: null,
      img: promoPadre.img || null,
      productoImg: promoPadre.img || null,
      promo: { ...promoPadre, nombrePadre: promoPadre.nombre },
      tipoModulo: promoPadre.tipo || null, // Agregar el tipo de módulo
    };
    
    // Eliminamos el nombre del objeto promo para que en el resumen use el nombre de la promo y no el genérico (ej: "Promo2")
    if (nuevaPromo.promo.nombre) delete nuevaPromo.promo.nombre;

    setPromosSeleccionadas((prev) => [...prev, nuevaPromo]);
    const etiqueta = tipoSeleccion ? `${nombreFinal} (${tipoSeleccion})` : nombreFinal;
    showSuccess(`${etiqueta} agregada con éxito`);
    setMostrarModalAgregarMas(true);
  }
};



const confirmarPreparacion = () => {
  if (!promoTemporal) return;

  const nombrePromo = promoTemporal.promo?.nombre || promoTemporal.nombre;
  const precioPromo = promoTemporal.promo?.precio || promoTemporal.precio;

  // 🔹 Validar bebida si la promo tiene bebida
  if (promoTemporal.bebida && !bebidaSeleccionada) {
    showError("Debes seleccionar una bebida antes de continuar");
    return;
  }

  if (!nombrePromo || !precioPromo) {
    showError("La promoción no está bien definida.");
    return;
  }

  let preparacionFinal = null;
  let hamburguesas = [];

  // 🔹 Validación de hamburguesas solo si la promo tiene preparacion
  if (promoTemporal.preparacion) {
    hamburguesas = Object.values(preparacionMultiple);

    if (hamburguesas.length !== cantidadHamburguesas) {
      showError("Debes elegir la proteína de cada hamburguesa.");
      return;
    }
    if (hamburguesas.some((h) => !h.proteina)) {
      showError("Debes seleccionar Carne o Pollo en cada hamburguesa.");
      return;
    }

    // 🔹 Procesar texto de preparación
    const conteo = hamburguesas.reduce((acc, h) => {
      acc[h.proteina] = (acc[h.proteina] || 0) + 1;
      return acc;
    }, {});

    preparacionFinal = Object.entries(conteo)
      .map(([tipo, cantidad]) => `${tipo} (x${cantidad})`)
      .join(", ");
  }

  const imagenPromo = promoTemporal.img || promoTemporal.parentPromo?.img || null;

  // 🔹 Crear objeto de la promo
  const nuevaPromo = {
    id: nanoid(),
    nombre: nombrePromo,
    preparacion: preparacionFinal, // null si no hay preparacion
    precio: precioPromo,
    img: imagenPromo,
    productoImg: imagenPromo,
    promo: {
      ...promoTemporal,
      img: imagenPromo,
      nombrePadre: promoTemporal.nombrePadre || promoTemporal.parentPromo?.nombre || null,
    },
    hamburguesas, // vacío si no hay preparacion
    bebidaSeleccionada: bebidaSeleccionada || null,
    tipoModulo: promoTemporal.tipo || null, // Agregar el tipo de módulo
  };

  if (nuevaPromo.promo.nombre) delete nuevaPromo.promo.nombre;

  // Actualizar estado funcionalmente (el useEffect maneja la persistencia)
  setPromosSeleccionadas(prev => [...prev, nuevaPromo]);
  showSuccess(`${nuevaPromo.nombre} agregada con éxito`);

  // 🔹 Limpiar estados
  setPromoTemporal(null);
  setPreparacionMultiple({});
  setMostrarModalPreparacion(false);
  setMostrarModalAgregarMas(true);
};



  const volverAElegirPromo = () => {
    setPromoSeleccionada(null);
    setPreparacion("");
    setMostrarModalPreparacion(false);
  };

  const toggleExclusion = (ingrediente) => {
  setExclusiones((prev) =>
    prev.includes(ingrediente)
      ? prev.filter((i) => i !== ingrediente)
      : [...prev, ingrediente]
  );
};

const manejarListoHamburguesa = () => {
  if (!proteinaSeleccion) {
    showError("Debes seleccionar Carne o Pollo antes de continuar");
    return;
  }

  // Guardar selección de proteína + exclusiones
  setPreparacionMultiple((prev) => ({
    ...prev,
    [hamburguesaExpandida]: {
      proteina: proteinaSeleccion,
      exclusiones: [...exclusiones],
    },
  }));

  // Limpiar temporal para la siguiente hamburguesa
  setProteinaSeleccion(null);
  setExclusiones([]);

  // Cerrar expandido
  setHamburguesaExpandida(null);
};




  return (
    <>
      {/* Modal principal animado */}

      <AnimatePresence>
        {isOpen && !mostrarModalPreparacion && !mostrarModal && !mostrarModalAgregarMas && !isImageExpanded && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50"
            onClick={onClose}
          >
            {/* Contenedor para detener el cierre al hacer clic adentro */}
            <div className="relative w-full h-full flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
              
              {/* Flechas y cerrar estáticos fuera del contenido */}
              <button
                onClick={onClose}
                aria-label="Cerrar modal"
                className="fixed top-4 right-4 bg-black/30 py-2 rounded-full px-2 text-white transition z-50"
              >
                <FaTimes/>
              </button>

              <button
                onClick={() => irAnterior()}
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full shadow z-50"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                onClick={() => irSiguiente()}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full shadow z-50"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>

              <div className="fixed bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-50">
                {modalsFiltrados.map((_, i) => (
                  <span
                    key={i}
                    className={`w-4 h-4 rounded-full transition-all ${i === indexModalActual ? 'bg-yellow-400' : 'bg-gray-500'}`}
                  />
                ))}
              </div>

              <motion.div
  key={modalsFiltrados[indexModalActual].nombre}
  initial={{
    x: interactuando
      ? direccionUsuario > 0
        ? "100vw"
        : "-100vw"
      : "100vw",
    opacity: 0,
  }}
  animate={{ x: 0, opacity: 1 }}
  exit={{
    x: interactuando
      ? direccionUsuario > 0
        ? "-100vw"
        : "100vw"
      : "-100vw",
    opacity: 0,
  }}
  transition={{ type: "tween", duration: 0.7 }}
  onMouseDown={() => setInteractuando(true)}
  onTouchStart={() => setInteractuando(true)}
  onDragStart={() => setInteractuando(true)}
  onKeyDown={() => setInteractuando(true)}
  drag="x"
  dragConstraints={{ left: 0, right: 0 }}
  dragElastic={0.3}
  onDragEnd={(event, info) => {
    const offset = info.offset.x;
    const threshold = 100;
    if (offset > threshold) {
      setDireccionUsuario(-1);
      irAnterior();
    } else if (offset < -threshold) {
      setDireccionUsuario(1);
      irSiguiente();
    }
  }}
className={`rounded-2xl  w-[90%] max-w-sm sm:max-w-md lg:max-w-lg max-h-[80vh] overflow-y-auto relative mx-auto
  ${modalsFiltrados[indexModalActual].tipo === "lm" || modalsFiltrados[indexModalActual].tipo === "duo" ? "bg-transparent" : "bg-white"}`}
>
 {modalsFiltrados[indexModalActual].tipo === "duo" ? (
  <PromoDuo
    onAgregarPromo={handleAgregarPromoDuo}
    onSiguiente={handleSiguientePromoDuo}
    onInteraccion={() => setInteractuando(true)}
  />
) : modalsFiltrados[indexModalActual].tipo === "hd" ? (
  <PromoHotDog
    onAgregarPromo={handleAgregarPromoDuo}
    onSiguiente={handleSiguientePromoDuo}
  />
) : modalsFiltrados[indexModalActual].tipo === "lm" ? (
  <PLunesYmartes
    onAgregarPromo={handleAgregarPromoDuo}
    onSiguiente={handleSiguientePromoDuo}
  />
) : (
    <>
      {/* Imagen con overlay y degradado */}
      <div
        className="relative w-full h-[55vh] sm:h-[250px] cursor-pointer overflow-hidden rounded-t-2xl"
        onClick={() => setIsImageExpanded(modalsFiltrados[indexModalActual].img)}
      >
        <img
          src={modalsFiltrados[indexModalActual].img}
          alt={modalsFiltrados[indexModalActual].nombre}
          className="object-cover object-top w-full h-full select-none"
          draggable={false}
        />

        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent -mb-px" />

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-sm font-semibold gap-1 select-none pointer-events-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10l4.553-4.553M19.553 5.447L15 1m4.553 4.447L21 5m-6 6v8a2 2 0 002 2h8a2 2 0 002-2v-8m-8 0h8"
            />
          </svg>
          <span className="text-gray-400">Pulsa para ampliar</span>
        </div>
      </div>

      {/* Botones de promos */}
      <div className="flex justify-center gap-3 px-6 py-4 relative">
        {modalsFiltrados[indexModalActual].botones.map((botonNombre, i) => {
          const promo = modalsFiltrados[indexModalActual].promos[i];

          return (
            <div key={i} className="relative">
              <button
                onClick={(e) => {
                  if (promo?.subpromos) {
                    if (
                      mostrarPopover &&
                      promoConSubopciones?.nombre === promo.nombre
                    ) {
                      setMostrarPopover(false);
                      setPromoConSubopciones(null);
                      setPromoAnchor(null);
                    } else {
                      setPromoConSubopciones(promo);
                      setPromoAnchor(e.currentTarget);
                      setMostrarPopover(true);
                    }
                  } else {
                    handlePromoClick(modalsFiltrados[indexModalActual], promo);
                  }
                }}
                className="relative text-yellow-500 text-sm px-4 py-1.5 font-semibold rounded-md overflow-hidden border-2 border-white tracking-widest shadow-lg hover:text-yellow-600 transition-all duration-300"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400 to-transparent blur-sm animate-shine" />
                <span className="relative z-10">{botonNombre}</span>
              </button>

              {mostrarPopover &&
                promoConSubopciones?.nombre === promo?.nombre &&
                promo?.subpromos && (
                  <div className="absolute z-50 bottom-full mb-4 max-w-[90vw] w-auto min-w-[160px] rounded-lg bg-black/80 text-red-600 shadow-xl ring-1 ring-red-700/40 left-1/2 -translate-x-[40%] sm:left-[60%] sm:-translate-x-1/2">
                    <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-black/80 border-r border-b border-red-700/40 rotate-45"></div>
                    <div className="flex flex-col divide-y divide-yellow-700/40 text-sm">
                      {promo.subpromos.map((sub, j) => (
                        <button
                          key={j}
                          onClick={() => {
                            setMostrarPopover(false);
                            setPromoAnchor(null);
                            handlePromoClick(modalsFiltrados[indexModalActual], sub);
                          }}
                          className="flex items-center justify-between px-4 py-2 hover:bg-red-700/30 transition text-left font-semibold"
                        >
                          <span>{sub.nombre}</span>
                          <span className="text-red-600 text-xs">➤</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          );
        })}
      </div>

      {/* Texto inferior */}
      {!isImageExpanded && (
        <div className="px-6 pb-6 text-center text-gray-400">
          <h2 className="text-lg font-bold mb-1 uppercase">¡Promoción Especial!</h2>
          <p className="text-sm">
            Elige tu Promo favorita y completa los datos para tu pedido.
          </p>
        </div>
      )}
    </>
  )}
</motion.div>

            </div>
          </motion.div>
        )}
      </AnimatePresence>

     

      {/* Imagen ampliada con z-index alto */}
     {isImageExpanded && (
  <div
    className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50">
    
    <div className="relative z-50"> {/* Contenedor relativo para la imagen */}
      <img 
        src={isImageExpanded} 
        alt="Imagen ampliada" 
        className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl" 
      />

      <button 
        className="absolute top-2 right-2 rounded-full bg-black/70 text-gray-400 p-2 transition  z-50"
        onClick={() => setIsImageExpanded(null)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
             viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

  </div>
      )}

  <AnimatePresence>
  {mostrarModalPreparacion && promoTemporal && (
    <motion.div
      key={`modal-preparacion`}
      initial={{ x: "100vw", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: "100vw", opacity: 0 }}
      transition={{ type: "tween", duration: 0.7 }}
      className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-[70]"
    >
      <div className="rounded-xl p-6 shadow-xl w-[90%] bg-gradient-to-br from-white to-neutral-200 max-w-md text-yellow-500 outline-none relative">
        <motion.img
          src={Logo}
          alt="Logo"
          className="absolute inset-0 w-[500px] h-[500px] mx-auto my-auto opacity-10 md:opacity-15 object-contain select-none pointer-events-none"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 0.15 }}
          transition={{ duration: 1.5 }}
        />

        <div className="flex flex-col items-center gap-8 mb-8">

          {/* 🔸 SECCIÓN PREPARACIÓN */}
          {promoTemporal.preparacion && (
            <div className="w-full">
              <h3 className="text-center uppercase text-yellow-500 font-bold tracking-widest text-lg mb-6">
                Selecciona las preparaciones de tu combo
              </h3>

              <div className="relative grid grid-cols-2 sm:grid-cols-2 gap-4 w-full h-[250px]">
                {Array.from({ length: promoTemporal?.cantidad || 1 }).map((_, index) => {
                  const isExpanded = hamburguesaExpandida === index;

                  return (
                    <motion.div
                      key={index}
                      layout
                      onClick={() => setHamburguesaExpandida(index)}
                      className={`rounded-2xl shadow-lg cursor-pointer transition-all duration-300 border
                        ${isExpanded ? "absolute top-0 left-0 w-full h-full z-50 bg-black/10 backdrop-blur-lg" : "relative w-full h-full flex items-center justify-center bg-white/50"}
                      `}
                      style={{
                        backgroundImage: isExpanded ? `url(${PromoCarne})` : undefined,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      {!isExpanded && (
                        <FaHamburger
                          className={`mb-2 transition-all duration-300 ${
                            preparacionMultiple?.[index] ? "text-yellow-400 scale-110" : "text-gray-600"
                          }`}
                          size={32}
                        />
                      )}

                      {isExpanded && (
                        <div className="flex flex-col gap-4 p-6 bg-black/40 rounded-2xl w-full h-full overflow-y-auto">
                          <div className="flex-1 max-w-auto bg-black/30 backdrop-blur-xl rounded-full p-1 flex shadow-[0_2px_10px_rgba(0,0,0,0.5)] border border-white/10">
                            {["Carne", "Pollo"].map((opcion) => (
                              <button
                                key={opcion}
                                onClick={() => setProteinaSeleccion(opcion)}
                                className={`flex-1 px-2 py-1 rounded-full font-extrabold text-sm sm:text-base transition-all
                                  ${proteinaSeleccion === opcion
                                    ? "bg-gradient-to-r from-[#ff0000] via-[#ff9500] to-[#ffd500] text-white shadow-[0_2px_10px_rgba(255,180,0,0.4)] scale-105"
                                    : "bg-transparent text-white/80 hover:text-white hover:bg-white/10"
                                  }`}
                              >
                                {opcion}
                              </button>
                            ))}
                          </div>

                          {/* 🔹 Accordion exclusiones */}
                          <div className="w-full mt-4 mb-3 bg-black/50 rounded-xl shadow-sm pb-2">
                            <div
                              className="flex justify-between text-white items-center py-2 px-2 cursor-pointer active:scale-[0.98] transition-all"
                              onClick={() => setExclusionesAbierto(!exclusionesAbierto)}
                            >
                              <p className="font-bold">¿Deseas excluir algo de tu plato?</p>
                              <FaChevronDown
                                className={`mt-5 text-xl transition-transform duration-300 ${exclusionesAbierto ? "rotate-180" : ""}`}
                              />
                            </div>

                            {exclusionesAbierto && (
                              <div className="mt-3 px-4 pb-1 flex flex-col gap-3">
                                {ingredientes.map((ing, i) => (
                                  <label key={i} className="flex items-center gap-3 cursor-pointer select-none">
                                    <div
                                      onClick={() => toggleExclusion(ing)}
                                      className={`w-6 h-6 flex items-center justify-center rounded-md border transition-all
                                        ${exclusiones.includes(ing) ? "bg-neutral-500" : "border-gray-300 bg-white"}`}
                                    >
                                      {exclusiones.includes(ing) && (
                                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                          <path d="M5 13l4 4L19 7" />
                                        </svg>
                                      )}
                                    </div>
                                    <span className="text-white font-bold text-base">Sin {ing}</span>
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>

                          {/* 🔹 Botón Listo */}
                          <div className="w-full flex justify-end -mt-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                manejarListoHamburguesa();
                              }}
                              className="w-20 py-2 bg-yellow-400 text-white font-bold rounded-xl"
                            >
                              Listo
                            </button>
                          </div>
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              </div>

              <p className="text-base text-gray-400 text-center mt-3">
                Toca cada hamburguesa para definir su preparación
              </p>
            </div>
          )}

          {/* 🔸 SECCIÓN BEBIDA */}
          {promoTemporal.bebida && (
            <div className="w-full">
              <h3 className="text-center uppercase text-yellow-500 font-bold tracking-widest text-lg mb-4">
                Elige tu bebida
              </h3>

              <div className="flex flex-wrap justify-center gap-4">
                {["Coca-Cola", "7up", "Frescolita"].map((bebida, idx) => (
                  <button
                    key={idx}
                    onClick={() => setBebidaSeleccionada(bebida)}
                    className={`px-6 py-2 rounded-full font-semibold text-sm transition-all duration-300
                      border-2 ${
                        bebidaSeleccionada === bebida
                          ? "bg-yellow-400 text-white border-yellow-400 shadow-lg scale-105"
                          : "bg-white/90 text-gray-700 border-gray-200 hover:bg-yellow-50 hover:border-yellow-300"
                      }`}
                  >
                    {bebida}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* 🟡 Botones Volver y Confirmar */}
        <div className="flex gap-3">
          <button
            onClick={volverAElegirPromo}
            className="w-full bg-neutral-400 hover:bg-neutral-600 transition text-white font-semibold py-2 rounded-xl"
          >
            Volver
          </button>
          <button
            onClick={confirmarPreparacion}
            className="w-full bg-yellow-500 text-white font-semibold py-2 rounded-xl"
          >
            Confirmar
          </button>
        </div>
      </div>
    </motion.div>
  )}
</AnimatePresence>




      {/* Modal Agregar Más con animación */}
      <AnimatePresence>
        {mostrarModalAgregarMas && (
          <motion.div
            key="modal-agregar"
            initial={{ x: "100vw", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100vw", opacity: 0 }}
            transition={{ type: "tween", duration: 0.7 }}
            className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-[70]"
            
          >
           <div
        className="rounded-xl p-6 shadow-xl w-[90%] bg-gradient-to-br from-white to-neutral-200 max-w-md text-yellow-500 outline-none"
        
      >
       
      
              <h3 className="text-center text-lg font-bold mb-6">¿Deseás agregar algo más? </h3>
              <div className="flex gap-4">
                <button
                  onClick={() => {
                    setMostrarModalAgregarMas(false);
                    onClose();
                  }}
                  className="w-full bg-yellow-400 text-white font-extrabold py-2 rounded"
                >
                  Sí
                </button>
                <button
                  onClick={() => {
                    sessionStorage.setItem('modalVisto', 'true');
                    setMostrarModalAgregarMas(false);
                    setMostrarModal(true);
                    setTimeout(() => {
                      setMostrarModal(false);
                      navigate("/form");
                    }, 2000);
                  }}
                  className="w-full bg-gray-300 text-white font-semibold py-2 rounded"
                  
                >
                  No
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <PageModal 
        mostrarModal={mostrarModal} 
        onComplete={() => setMostrarModal(false)} 
      />
    </>
  );
};

export default ModalInicio;
